"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyGroupStatsToJSON = exports.SurveyGroupStatsFromJSONTyped = exports.SurveyGroupStatsFromJSON = exports.instanceOfSurveyGroupStats = void 0;
var runtime_1 = require("../runtime");
var SurveyGroupStatsSignificance_1 = require("./SurveyGroupStatsSignificance");
/**
 * Check if a given object implements the SurveyGroupStats interface.
 */
function instanceOfSurveyGroupStats(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyGroupStats = instanceOfSurveyGroupStats;
function SurveyGroupStatsFromJSON(json) {
    return SurveyGroupStatsFromJSONTyped(json, false);
}
exports.SurveyGroupStatsFromJSON = SurveyGroupStatsFromJSON;
function SurveyGroupStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'controlAverage': !(0, runtime_1.exists)(json, 'control_average') ? undefined : json['control_average'],
        'exposedAverage': !(0, runtime_1.exists)(json, 'exposed_average') ? undefined : json['exposed_average'],
        'deltaRate': !(0, runtime_1.exists)(json, 'delta_rate') ? undefined : json['delta_rate'],
        'controlPositiveCount': !(0, runtime_1.exists)(json, 'control_positive_count') ? undefined : json['control_positive_count'],
        'exposedPositiveCount': !(0, runtime_1.exists)(json, 'exposed_positive_count') ? undefined : json['exposed_positive_count'],
        'controlTotal': !(0, runtime_1.exists)(json, 'control_total') ? undefined : json['control_total'],
        'exposedTotal': !(0, runtime_1.exists)(json, 'exposed_total') ? undefined : json['exposed_total'],
        'significance': !(0, runtime_1.exists)(json, 'significance') ? undefined : (0, SurveyGroupStatsSignificance_1.SurveyGroupStatsSignificanceFromJSON)(json['significance']),
    };
}
exports.SurveyGroupStatsFromJSONTyped = SurveyGroupStatsFromJSONTyped;
function SurveyGroupStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'control_average': value.controlAverage,
        'exposed_average': value.exposedAverage,
        'delta_rate': value.deltaRate,
        'control_positive_count': value.controlPositiveCount,
        'exposed_positive_count': value.exposedPositiveCount,
        'control_total': value.controlTotal,
        'exposed_total': value.exposedTotal,
        'significance': (0, SurveyGroupStatsSignificance_1.SurveyGroupStatsSignificanceToJSON)(value.significance),
    };
}
exports.SurveyGroupStatsToJSON = SurveyGroupStatsToJSON;
